module.exports = __webpack_public_path__ + "static/media/driver-icon.49616a40.svg";